// extracted by mini-css-extract-plugin
export default {"row":"VirtualTableRow-row-cfNxh"};